import { Column } from "../../../../components/TableDataGridV2/types";
import { IDataAgrotoxico } from "../../../../types/api/geral/pesquisar-agrotoxico";

export const colunasAgrotoxicos: Column<IDataAgrotoxico>[] = [
    {
        id: 'id',
        label: 'Código',
        type: "text",
        filter: true,
        numeric: false,
        sortable: true,
        minWidth: 80,
    },
    {
        id: 'marca_comercial',
        label: 'Marca Comercial',
        type: "text",
        filter: true,
        numeric: false,
        sortable: true,
        minWidth: 150,
    },
    {
        id: 'ingrediente_ativo.nome',
        label: 'Ingrediente Ativo',
        type: "truncated",
        filter: false,
        numeric: false,
        sortable: false,
        minWidth: 80,
    },
    {
        id: 'titular_registro',
        label: 'Titular do Registro',
        type: "text",
        numeric: false,
        filter: true,
        sortable: true,
        minWidth: 150,
    },
    {
        id: 'classe',
        label: 'Classe',
        type: "text",
        numeric: false,
        filter: true,
        sortable: true,
        minWidth: 120,
    },
    {
        id: 'modo_acao',
        label: 'Modo de Ação',
        type: "text",
        numeric: false,
        filter: true,
        sortable: true,
        minWidth: 120,
    },
    {
        id: 'organico',
        label: 'Orgânico',
        type: "text",
        numeric: false,
        filter: true,
        sortable: true,
        minWidth: 100,
    }
];